import { useEffect } from "react";
import { useDispatch } from "react-redux";
import axios from "axios";
import { USER_LOADED, AUTH_ERROR } from "../../actions/types";

// Runs inside PersistGate (after rehydration) — fetches fresh workspace flags
// (hr_enabled, workspace_role, etc.) so stale cached state is overwritten.
export default function AuthRefresh() {
  const dispatch = useDispatch();

  useEffect(() => {
    let mounted = true;
    let intervalId = null;

    const refreshAuth = () => {
      const config = { withCredentials: true };

      axios
        .get("/api/auth/me", config)
        .then((res) => {
          if (mounted && res.status === 200) {
            dispatch({
              type: USER_LOADED,
              payload: res.data,
            });
            if (!intervalId) {
              intervalId = window.setInterval(refreshAuth, 60000);
            }
          }
        })
        .catch(() => {
          if (mounted) {
            dispatch({ type: AUTH_ERROR });
            if (intervalId) {
              window.clearInterval(intervalId);
              intervalId = null;
            }
          }
        });
    };

    refreshAuth();

    const handleVisibility = () => {
      if (!document.hidden) {
        refreshAuth();
      }
    };

    window.addEventListener("focus", refreshAuth);
    document.addEventListener("visibilitychange", handleVisibility);

    return () => {
      mounted = false;
      if (intervalId) {
        window.clearInterval(intervalId);
      }
      window.removeEventListener("focus", refreshAuth);
      document.removeEventListener("visibilitychange", handleVisibility);
    };
  }, [dispatch]);

  return null;
}
